<template functional>
  <div>
    <span
      v-if="props.rowValue != null && props.rowValue != '1753-01-01T00:00:00'"
      :style="{
        color: $options.colorDate(props.row[props.column], props)
          ? 'green'
          : 'red'
      }"
    >
      <i class="el-icon-time"></i>
      {{ $options.setFormatDate(props) }}
    </span>
    <span v-else> </span>
  </div>
</template>

<script>
import { formatDate } from "@/utils";
export default {
  name: "DatetimeCobroFormatter",
  formatDate,
  setFormatDate(props) {
    // console.log("www", props);
    const date = props.row[props.column];
    return formatDate(date, "DD/MM/YYYY");
  },
  colorDate(date, props) {
    // let cobro = new Date(date).getMonth();
    // let compromiso = new Date(props.row.DueDate).getMonth();
    // // console.log("weqwqw", props)
    // if (cobro != compromiso) {
    //   return false;
    // } else if (cobro === compromiso) {
    //   return true;
    // }
    if (props.row.DaysLate == 0) {
      return true;
    }
    return false;
  }
};
</script>
